import { Component, OnInit, ViewChild } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { Router } from "@angular/router";
import { MatInput } from "@angular/material";
import { DatePipe } from "@angular/common";
import { saveAs } from "file-saver";
import { CommonService } from "../../../services/common.service";

// import { Authen } from "../../../../../Server/auth.json";
@Component({
  selector: "app-existing-bookings",
  templateUrl: "./existing-bookings.component.html",
  styleUrls: ["./existing-bookings.component.css"],
  providers: [DatePipe]
})
export class ExistingBookingsComponent implements OnInit {
  //Unused TBD - Yugant
  // @ViewChild("input", { read: MatInput }) matInput: MatInput;
  // @ViewChild("input2", { read: MatInput }) matInput2: MatInput;
  @ViewChild("input3", { read: MatInput }) matInput3: MatInput;
  @ViewChild("input4", { read: MatInput }) matInput4: MatInput;

  ebScreenTitle: string = "Manage Booking";
  ebInvalidDate = false;
  ebShowSingle1 = true;
  ebShowMultiple1 = true;
  ebFinal;
  ebdownd = true;
  ebSearchlist: boolean = true;
  ebmyDate = new Date();
  ebJourneyDate = false;
  ebSearch_details;
  ebisFname = false;
  ebisLname = false;
  ebTomorrow1;
  ebisOrd = false;
  ebisPnr = false;
  ebDisablebtn = true;
  ebBookingDate = false;
  ebTomorrow;
  ebBooking_ref: any = "asdasd";
  ebp: number = 1;
  ebSearch_result_list: any = [];
  search_result_list1: any = [];
  order_Id_list: any = [];
  search_detail_list: any = [];
  existingbooking: boolean = true;
  bookinglist: boolean = false;
  booking_details: any = "";
  booking_details_info: any = [];
  // segment_details: any = "";
  pax_detail: any = "";
  segment_details: any = [];
  Ticket_detail: any = [];
  segment_details1: any = [];
  segment_details2: any = [];
  selectedOutboundPaxArray = [];
  selectedInboundPaxArray = [];
  loader: any = false;
  isloader: any = false;
  uid;
  cancelbtn;
  BOOKING_STATUS;
  cancelHistory: any = [];
  isCancelOpen: boolean = false;
  isJpNumber: boolean = false;
  noresult: any = "";
  booking_status: any = [
    { key: 2, value: "Booked" },
    { key: 4, value: "Failed" },
    { key: 1, value: "Pending" }
  ];
  TransactionscreenId: any = "";
  Errmessage: any = "";
  MilesYouHave: any = "";
  totalMiles: any = "";
  Rpm: any = 0.3;
  MilesRefunded: any = 0;
  CancellationMiles: any = 0;
  CancellationMilesInbound: any = 0;
  cancelResponse: any = {};
  Cost_Additional_JpMiles: any = 0;
  TOTAL_AMOUNT: any = 0;
  rate_per_miles: any = 1;
  GST_ON_MILES: any = 0;
  newDate: any = new Date();
  myDate: any = new Date();
  totalItems: number = 1;
  ebTypeOfRedemption: any = "A";
  ebTypeOfRedem: any = "A";
  initialPageCount: number = 1;
  constructor(
    private vernostService: VernostServiceService,
    private commonService: CommonService,
    private router: Router,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.isJpNumber = false;
    this.cancelbtn = true;
    this.isCancelOpen = false;
    this.checkUID();
    this.ebSearch_details = {
      jp_number: "",
      order_id: "",
      first_name: "",
      last_name: "",
      airlinepnr: "",
      status: "E",
      tripdate_from: "",
      tripdate_to: "",
      bookingdate_from: "",
      bookingdate_to: "",
      Ticket_No: ""
    };
  }

  checkUID() {
    this.uid = localStorage.getItem("uid");
    if (this.uid == "" || this.uid == undefined) {
      this.router.navigate(["/login"]);
    }
  }

  searchForm() {
    this.searchData();
    this.segment_details1 = [];
    this.segment_details2 = [];
    this.selectedOutboundPaxArray = [];
    this.selectedInboundPaxArray = [];
    this.existingbooking = true;
    this.bookinglist = false;
    this.Errmessage = "";
    this.CancellationMilesInbound = 0;
    this.CancellationMiles = 0;
    this.initialPageCount =1;
  }
  pageCount(count) {
    this.ebp = count;
    this.searchData()
    console.log("P:::", this.ebp);
  }
  searchData() {
    //  alert(this.search_details.bookingdate_from);
    this.noresult = "";
    if (this.isJpNumber == false && this.ebisPnr == false
      && this.ebisOrd == false && this.ebisFname == false && this.ebisLname == false) {

      this.loader = true;
      this.ebSearchlist = false;
      this.cancelbtn = true;
      this.ebSearch_result_list = [];
      this.search_result_list1 = [];
      this.order_Id_list = [];
      this.search_detail_list = [];

      var Todate = this.ebSearch_details.bookingdate_to
      if (Todate != "") {
        Todate.setDate(Todate.getDate());
      }
      this.ebSearch_details.bookingdate_from = this.datePipe.transform(
        this.ebSearch_details.bookingdate_from,
        "yyyy-MM-dd"
      );
      Todate = this.datePipe.transform(
        Todate,
        "yyyy-MM-dd"
      );
      var boofrom = this.ebSearch_details.bookingdate_from;
      var bookto = Todate;

      var AirLine_Pnr = this.ebSearch_details.airlinepnr;

      var jp_number = "";
      if (this.ebTypeOfRedemption == 'A') {
        jp_number = this.ebSearch_details.jp_number;
      }
      if (this.ebTypeOfRedemption == 'R') {
        jp_number = "00" + this.ebSearch_details.jp_number
      }
      var BOOKING_REF_NO = (this.ebSearch_details.order_id.toString().length <= 15 ? this.ebSearch_details.order_id.slice(4, this.ebSearch_details.order_id.length) : this.ebSearch_details.order_id);

      var data = {
        booking_fromdate: boofrom,
        booking_todate: bookto,
        jp_number: jp_number,
        order_id: BOOKING_REF_NO,
        first_name: this.ebSearch_details.first_name,
        last_name: this.ebSearch_details.last_name,
        airlinepnr: AirLine_Pnr.toUpperCase(),
        status: this.ebSearch_details.status,
        Ticket_No: this.ebSearch_details.Ticket_No,
        pagination: this.ebp,
        typeOfRedemption: this.ebTypeOfRedemption,
        initialPageCount: this.initialPageCount
      };

      this.vernostService.getExistingBooking(data).subscribe(getExistingBookingResponse => {
        var Data = getExistingBookingResponse;
        this.ebTypeOfRedem = this.ebTypeOfRedemption;
        var count = Data[0].count;
        this.initialPageCount = Data[0].count
        this.totalItems = count;
        this.ebSearch_result_list = Data[0].result;
        // this.search_result_list = response;

        for (var i = 0; i < this.ebSearch_result_list.length; i++) {
          this.ebSearch_result_list[i].Booking_Ref = (this.ebSearch_result_list[i].Booking_Ref.toString().length < 12 ? "JPUB" + this.ebSearch_result_list[i].Booking_Ref : this.ebSearch_result_list[i].Booking_Ref);
        }

        var Search_Details = [];
        for (var j = 0; j < this.ebSearch_result_list.length; j++) {
          if (this.order_Id_list.indexOf(this.ebSearch_result_list[j].Booking_Ref) == -1) {
            this.order_Id_list.push(this.ebSearch_result_list[j].Booking_Ref);
            Search_Details.push(this.ebSearch_result_list[j]);
          }
        }
        this.search_detail_list = this.ebSearch_result_list;
        if (
          this.search_detail_list.length == 0 ||
          this.search_detail_list == undefined ||
          this.search_detail_list == ""
        ) {
          this.noresult = "Result Not Found";
          this.loader = false;
        } else {
          this.loader = false;
        }
      });
    }
  }

  paxObject(obj, paxType?, ticketNumber?, airlinePnr?) {
    let selectedPaxObj = {
      FIRST_NAME: paxType != 'InboundOutboundPax' ? obj.firstName : obj.FIRST_NAME,
      LAST_NAME: paxType != 'InboundOutboundPax' ? obj.lastName : obj.LAST_NAME,
      PASSENGER_TYPE: paxType != 'InboundOutboundPax' ? obj.paxType : obj.PASSENGER_TYPE,
      TITLE: paxType != 'InboundOutboundPax' ? obj.title : obj.TITLE,
      AIRLINE_PNR: paxType != 'InboundOutboundPax' ? obj.airLinePnr : airlinePnr,
      TICKET_NO: paxType != 'InboundOutboundPax' ? obj.ticketNumber : ticketNumber,
      PAX_ID: paxType != 'InboundOutboundPax' ? obj.paxId : "",
      CANCELLATION_CHARGE: obj.cancellationCharge,
      EMT_FEE: paxType != 'InboundOutboundPax' ? obj.emtFee : 500,
      JP_FEE: 0,
      REFUND_AMOUNT: paxType != 'InboundOutboundPax' ? obj.refundAmount : "",
      TRIP_TYPE: paxType != 'InboundOutboundPax' ? obj.tripType : obj.TRIP_TYPE,
      MODE: paxType != 'InboundOutboundPax' ? obj.possibleMode : ""
    }
    return selectedPaxObj;
  }

  outboundCheckBox(event) {
    this.selectedOutboundPaxArray = [];
    if (this.pax_detail != "") {
      if (event.target.checked) {
        for (let i = 0; i < this.pax_detail.length; i++) {
          let add = <HTMLInputElement>(
            document.getElementById("outboundChild" + i)
          );
          add.checked = true;
          if (this.passengerDetails[i].tripType == "OutBound") {
            this.selectedOutboundPaxArray.push(this.paxObject(this.passengerDetails[i]));
          }

        }
      } else {
        for (let i = 0; i < this.pax_detail.length; i++) {
          let add = <HTMLInputElement>(
            document.getElementById("outboundChild" + i)
          );
          add.checked = false;
        }
      }
    }
  }

  selectedOutbound(event, pax) {
    if (event.target.checked) {
      this.selectedOutboundPaxArray.push(pax);
    } else {
      var selectedPaxIndex = this.selectedOutboundPaxArray.indexOf(pax);
      if (selectedPaxIndex > -1) {
        this.selectedOutboundPaxArray.splice(selectedPaxIndex, 1);
      }
      let add = <HTMLInputElement>document.getElementById("outboundId");
      add.checked = false;
    }

  }

  inboundCheckBox(event) {
    this.selectedInboundPaxArray = [];
    if (this.pax_detail != "") {
      if (event.target.checked) {
        for (let x = 0; x < this.pax_detail.length; x++) {
          let add = <HTMLInputElement>(document.getElementById("inboundChild" + x));
          add.checked = true;
        }
        for (var i = 0; i < this.passengerDetails.length; i++) {
          if (this.passengerDetails[i].tripType == "InBound") {
            this.selectedInboundPaxArray.push(this.paxObject(this.passengerDetails[i]));
          }
        }
      } else {
        for (let p = 0; p < this.pax_detail.length; p++) {
          let add = <HTMLInputElement>(
            document.getElementById("inboundChild" + p)
          );
          add.checked = false;
        }
      }
    }
  }

  IsEmptyVal: boolean = false;
  isEmpty() {
    if (this.ebSearch_details.jp_number == '' && this.ebSearch_details.airlinepnr == '' &&
      this.ebSearch_details.order_id == '' && this.ebSearch_details.Ticket_No == '' &&
      this.ebSearch_details.first_name == '' && this.ebSearch_details.last_name == ''
      && this.ebSearch_details.status == "E" && (this.ebSearch_details.bookingdate_from == ""
        || this.ebSearch_details.bookingdate_to == "")) {

      this.IsEmptyVal = false;
    } else {
      this.IsEmptyVal = true;

    }

  }
  selectedInbound(event, pax) {
    if (event.target.checked) {
      this.selectedInboundPaxArray.push(pax);
    } else {
      var selectedPaxIndex = this.selectedInboundPaxArray.indexOf(pax);
      if (selectedPaxIndex > -1) {
        this.selectedInboundPaxArray.splice(selectedPaxIndex, 1);
      }
      let add = <HTMLInputElement>document.getElementById("inboundId");
      add.checked = false;
    }

  }

  cancelBookingPax() {

    var mode = "";
    var OutBound = "";
    this.selectedOutboundPax.forEach(element => {
      OutBound = OutBound + element.PAX_ID + "-";
      mode = element.MODE;

    });
    OutBound = OutBound.substring(0, OutBound.length - 1);
    var InBound = "";
    this.selectedInboundPax.forEach(element => {
      InBound = InBound + element.PAX_ID + "-";
      mode = element.MODE;

    });
    InBound = InBound.substring(0, InBound.length - 1);
    // mode = mode.substring(0, mode.length - 1);

    mode = mode.split("-")[0];

    // this.vernostService.getJSON("getFleJsonData").subscribe(result => {
    var array = {
      // Authentication: result["Authentication"],
      transactionscreenId: this.TransactionscreenId,
      outBoundPaxIds: OutBound,
      inBoundPaxIds: InBound,
      isPartialCancel: false,
      mode: mode
    };

    this.vernostService
      .postBuisnessApi("/cancellation", array)
      .subscribe(resp => {
        this.cancelResponse = resp;

        if (resp["isRequested"] == true || resp["isRequested"] == "true") {

          this.changeStatus();
        }
        if (
          resp["isCancelled"] == false &&
          resp["isRequested"] == false &&
          resp["isRefunded"] == false
        ) {

          this.Errmessage = resp["msg"];
        }
      });
  }

  isCheckedCancel: boolean = false;
  checkCancelBooking() {
    if (this.isCheckedCancel == false) {
      this.isCheckedCancel = true;
    }
  }

  selectTypeOfRedemption(type) {
    this.ebTypeOfRedemption = type;
  }

  passengerDetails: any = [];
  selectedInboundPax: any = [];
  selectedOutboundPax: any = [];
  booking_ref_no: any;
  book_details(param, type) {

    if (type == "book") {
      this.loader = true;
    }

    let data = {
      booking_ref: param,
      typeOfRedemption: this.ebTypeOfRedemption
    };
    console.log("data", data);
    this.vernostService.getBookingDetails(data).subscribe(response => {
      var transactionscreenId = response[0].booking[0].TRIP_ID;
      this.TransactionscreenId = transactionscreenId.split("#")[1];
      var resp = undefined;
      this.loader = false;
      this.booking_details_info = response[0].booking[0];
      this.booking_details = response[0].booking;
      this.booking_ref_no = (this.booking_details_info.ORDER_ID.toString().length < 12 ? "JPUB" + this.booking_details_info.ORDER_ID : this.booking_details_info.ORDER_ID)
      this.segment_details = response[0].segment_details;
      console.log(" this.segment_details=", JSON.stringify(this.segment_details));
      for (var x = 0; x < response[0].segment_details.length; x++) {
        if (response[0].segment_details[x].SEGMENT_NO == 1) {
          this.segment_details1.push(response[0].segment_details[x]);
        }
        if (response[0].segment_details[x].SEGMENT_NO == 2) {
          this.segment_details2.push(response[0].segment_details[x]);
        }
      }

      this.pax_detail = response[0].pax_detail;
      this.BOOKING_STATUS = this.booking_details.BOOKING_STATUS;
      this.MilesYouHave = this.booking_details_info.MILES_REQUIRED;
      this.TOTAL_AMOUNT = this.booking_details_info.TOTAL_AMOUNT;
      this.TOTAL_AMOUNT = parseFloat(this.TOTAL_AMOUNT).toFixed(2);
      this.GST_ON_MILES = this.booking_details_info.GST_ON_MILES;
      this.GST_ON_MILES = parseFloat(this.GST_ON_MILES).toFixed(2);

      if (this.booking_details_info.RATE_PER_MILE == undefined || this.booking_details_info.RATE_PER_MILE == null
        || this.booking_details_info.RATE_PER_MILE == 0) {
        this.rate_per_miles = 0.4;
      } else {
        this.rate_per_miles = Number(this.booking_details_info.RATE_PER_MILE);
      }
      // console.log(this.booking_details_info.FEES,"this.rate_per_miles",this.rate_per_miles);
      this.Cost_Additional_JpMiles =
        Number(this.booking_details_info.MORE_TO_BUY_JPMILES) * this.rate_per_miles;
      this.Cost_Additional_JpMiles = parseFloat(
        this.Cost_Additional_JpMiles
      ).toFixed(2);


      this.selectedOutboundPax = [];
      this.selectedInboundPax = [];
      if (resp != undefined && resp["passengerDetails"] != undefined) {
        this.passengerDetails = resp["passengerDetails"];
        for (var i = 0; i < this.passengerDetails.length; i++) {
          if (this.passengerDetails[i].tripType == "InBound") {
            this.selectedInboundPax.push(this.paxObject(this.passengerDetails[i]));

            var CANCELLATION_CHARGE;
            if (
              this.passengerDetails[i].cancellationCharge != undefined ||
              this.passengerDetails[i].cancellationCharge != null ||
              this.passengerDetails[i].cancellationCharge != "" ||
              this.passengerDetails[i].cancellationCharge != "NA"
            ) {
              CANCELLATION_CHARGE = this.passengerDetails[i]
                .cancellationCharge;

            } else {
              CANCELLATION_CHARGE = 0;

            }
            var EMT_FEE;
            if (
              this.passengerDetails[i].emtFee != undefined ||
              this.passengerDetails[i].emtFee != null ||
              this.passengerDetails[i].emtFee != ""
            ) {
              EMT_FEE = this.passengerDetails[i].emtFee;
            } else {
              EMT_FEE = 0;
            }
            this.CancellationMilesInbound =
              this.CancellationMilesInbound +
              (parseFloat(CANCELLATION_CHARGE) + parseFloat(EMT_FEE));
          }
          if (this.passengerDetails[i].tripType == "OutBound") {
            this.selectedOutboundPax.push(this.paxObject(this.passengerDetails[i]));
            if (
              this.passengerDetails[i].cancellationCharge != undefined &&
              this.passengerDetails[i].cancellationCharge != null &&
              this.passengerDetails[i].cancellationCharge != "" &&
              this.passengerDetails[i].cancellationCharge != "NA"
            ) {
              CANCELLATION_CHARGE = this.passengerDetails[i].cancellationCharge;
            } else {
              CANCELLATION_CHARGE = 0;
            }
            if (
              this.passengerDetails[i].emtFee != undefined ||
              this.passengerDetails[i].emtFee != null ||
              this.passengerDetails[i].emtFee != ""
            ) {
              EMT_FEE = this.passengerDetails[i].emtFee;
            } else {
              EMT_FEE = 0;
            }
            this.CancellationMiles =
              this.CancellationMiles +
              (parseFloat(CANCELLATION_CHARGE) + parseFloat(EMT_FEE));
            // this.MilesRefunded = (this.MilesYouHave) / (0.3);
          }
        }
      } else {
        this.passengerDetails = this.pax_detail;
        var Oneway_Ticket = [];
        var Return_Ticket = [];
        this.Ticket_detail = response[0].Ticket_detail;
        this.Ticket_detail.forEach(element => {
          if (element.SEGMENT_REF_NO == 1) {
            Oneway_Ticket.push(element);
          } else {
            Return_Ticket.push(element);
          }
        });
        var Ticket_Numbers = [];
        // console.log(Return_Ticket, "Oneway_Ticket", Oneway_Ticket);
        var k = 0;
        Oneway_Ticket.forEach(element => {
          if (Return_Ticket.length == 0) {
            if (element.TICKET_NO != undefined && element.TICKET_NO != null && element.TICKET_NO != "") {
              Ticket_Numbers.push(element.TICKET_NO);
            } else {
              Ticket_Numbers.push("NA");
            }
          } else {
            if (element.TICKET_NO != undefined && element.TICKET_NO != null && element.TICKET_NO != "") {
              if (Return_Ticket != null && Return_Ticket[k] != null && Return_Ticket[k].TICKET_NO != null) {
                Ticket_Numbers.push(element.TICKET_NO + " , " + Return_Ticket[k].TICKET_NO)
              } else {
                Ticket_Numbers.push(element.TICKET_NO);
              }
            }
          }
          k++;
        })
        for (var t = 0; t < this.passengerDetails.length; t++) {
          if (this.booking_details_info.TRIP_TYPE != "ONEWAY") {
            this.selectedInboundPax.push(this.paxObject(this.passengerDetails[t], 'InboundOutboundPax', Ticket_Numbers[t], response[0].segment_details[0].AIRLINE_PNR));
          }
          if (
            this.booking_details_info.TRIP_TYPE == "ONEWAY" ||
            this.booking_details_info.TRIP_TYPE != "ONEWAY"
          ) {
            this.selectedOutboundPax.push(this.paxObject(this.passengerDetails[t], 'InboundOutboundPax', Ticket_Numbers[t], response[0].segment_details[0].AIRLINE_PNR));
          }
        }
      }
      var cancellationFee = this.CancellationMilesInbound + this.CancellationMiles;
      this.CancellationMiles = cancellationFee / 0.3;
      this.CancellationMiles = Math.round(this.CancellationMiles);
      this.MilesRefunded = this.MilesYouHave - this.CancellationMiles;
      this.MilesRefunded = Math.round(this.MilesRefunded);
      this.totalMiles =
        parseInt(this.booking_details_info.MILES_REQUIRED) +
        parseInt(this.booking_details_info.MORE_TO_BUY_JPMILES);
    });

    if (type == "book") {
      this.existingbooking = false;
      this.bookinglist = true;
      this.isCancelOpen = false;
    } else {
      this.isCancelOpen = true;
    }
  }

  cancelBooking(ORDER_ID, type) {
    // alert("dd")

    this.isloader = true;
    this.cancelbtn = true;

    var array = {
      FB_BOOKING_REF_NO: this.booking_details_info.Booking_Ref,
      ORDER_ID: this.booking_details_info.ORDER_ID,
      ORIGIN: this.segment_details1[0].ORIGIN,
      DESTINATION: this.segment_details1[0].DESTINATION,
      TRANSACTION_ID: this.booking_details_info.TRANSACTION_ID,
      TRIP_ID: this.booking_details.TRIP_ID,
      JP_NUMBER: this.booking_details_info.JP_NUMBER,
      PRODUCT_TYPE: this.booking_details_info.ORDER_TYPE,
      TIER: this.booking_details_info.TIER,
      CANCELLED_BY: this.uid,
      CREATED_BY: this.uid
    };

    this.vernostService
      .cancelHistoryFlightBooking(array)
      .subscribe(response => {
        if (response[0].status == "Success") {

          this.cancelBookingPax();
          // this.cancelbtn = false;
        }
        if (response[0].status == "failed") {

          // this.cancelbtn = true;
        }
      });
  }

  changeStatus() {
    var updateArray = {
      BOOKING_STATUS: 11,
      TRANSACTION_STATUS: "",
      MEMBER_POINT_BALANCE: "",
      ORDER_ID: this.booking_details_info.ORDER_ID,
      FB_BOOKING_REF_NO: this.booking_details_info.Booking_Ref
    };
    this.vernostService.cancelFlightBooking(updateArray).subscribe(response => {
      if (response[0]["status"] == "Success") {

        this.cancelbtn = false;
        this.isloader = false;
        document.getElementById("dissmissModal").click();
        this.refundMiles();
      } else {

        this.cancelbtn = true;
        this.isloader = false;
      }
    });
  }
  refundMiles() {
    var array = {
      TRANSACTION_ID: this.TransactionscreenId,
      REFUND_RESPONSE_DESC: this.cancelResponse,
      BOOKING_REF_NO: this.booking_details_info.FB_BOOKING_REF_NO,
      ORDER_ID: this.booking_details_info.ORDER_ID,
      MILES_REFUNDED: this.MilesRefunded,
      EMAIL: this.pax_detail[0].EMAIL_ID
    };
    this.vernostService.postData("insertRefund", array).subscribe(resp => {

    });
  }
  jpNumberValidation() {
    this.ebDisablebtn = false;
    var JPNo = this.ebSearch_details.jp_number;
    this.isJpNumber = this.commonService.validation('jpnumbervalidation', /^[A-Za-z0-9_]+$/, JPNo);
  }

  fnameValidation() {
    this.ebDisablebtn = false;
    var JPNo = this.ebSearch_details.first_name;
    this.ebisFname = this.commonService.validation('fname', /^[A-Za-z]+$/, JPNo);
  }
  lnameValidation() {
    this.ebDisablebtn = false;
    var JPNo = this.ebSearch_details.last_name;
    this.ebisLname = this.commonService.validation('fname', /^[A-Za-z]+$/, JPNo);
  }

  orderValidation() {
    this.ebDisablebtn = false;
    var JPNo = this.ebSearch_details.order_id;
    this.ebisOrd = this.commonService.validation('orderValidation', /^[A-Za-z0-9_]+$/, JPNo);

  }
  orderValidation1() {
    this.ebDisablebtn = false;
    var JPNo = this.ebSearch_details.order_id;
    this.ebisOrd = this.commonService.validation('orderValidation1', '', JPNo);
  }

  pnrValidation() {
    this.ebDisablebtn = false;
    var JPNo = this.ebSearch_details.airlinepnr;
    this.ebisPnr = this.commonService.validation('pnrValidation', /^[A-Za-z0-9_]+$/, JPNo);
  }

  toggleDisable1() {
    this.ebBookingDate = true;

    if (
      this.ebSearch_details.tripdate_from.length != "" ||
      this.ebSearch_details.tripdate_to.length != ""
    ) {
      this.ebBookingDate = true;
    } else {
      this.ebBookingDate = false;
    }

    if (this.ebSearch_details.tripdate_from.length != "") {
      this.ebTomorrow = this.ebSearch_details.tripdate_from;
      this.ebTomorrow.setDate(this.ebTomorrow.getDate() + 1);
    }
  }
  toggleDisable2() {
    this.ebJourneyDate = true;

    this.ebSearch_details.bookingdate_to = "";
    // if (
    //   this.search_details.bookingdate_from.length != "" ||
    //   this.search_details.bookingdate_to.length != ""
    // ) {
    //   this.journeydate = true;
    // } else {
    //   this.journeydate = false;
    // }

    // if (this.search_details.bookingdate_from.length != "") {
    //   this.tomorrow1 = this.search_details.bookingdate_from;
    //   this.tomorrow1.setDate(this.tomorrow1.getDate() + 1);
    // }
  }

  checkempty() {
    if (
      this.ebSearch_details.jp_number.length == 0 &&
      this.ebSearch_details.last_name.length == 0 &&
      this.ebSearch_details.first_name.length == 0 &&
      this.ebSearch_details.airlinepnr.length == 0 &&
      this.ebSearch_details.order_id.length == 0 &&
      this.ebSearch_details.status == "E"
    ) {
      this.ebDisablebtn = true;
    }

    if (
      (this.ebSearch_details.jp_number.length != 0 ||
        this.ebSearch_details.last_name.length != 0 ||
        this.ebSearch_details.first_name.length != 0 ||
        this.ebSearch_details.airlinepnr.length != 0 ||
        this.ebSearch_details.order_id.length != 0 ||
        this.ebSearch_details.status != "E") &&
      (this.ebSearch_details.bookingdate_from != "" &&
        this.ebSearch_details.bookingdate_to != "")
    ) {
      this.ebDisablebtn = false;
    }

    if (
      (this.ebSearch_details.jp_number.length != 0 ||
        this.ebSearch_details.last_name.length != 0 ||
        this.ebSearch_details.first_name.length != 0 ||
        this.ebSearch_details.airlinepnr.length != 0 ||
        this.ebSearch_details.order_id.length != 0 ||
        this.ebSearch_details.status != "E") &&
      (this.ebSearch_details.bookingdate_from == "" &&
        this.ebSearch_details.bookingdate_to == "")
    ) {
      this.ebDisablebtn = false;
    }

    if (
      this.ebSearch_details.bookingdate_from == "" &&
      this.ebSearch_details.bookingdate_to != ""
    ) {
      this.ebDisablebtn = true;
    }

    if (
      this.ebSearch_details.bookingdate_from != "" &&
      this.ebSearch_details.bookingdate_to == ""
    ) {
      this.ebDisablebtn = true;
    }
  }

  checkStatus1() {
    //alert(this.search_details.bookingdate_from);
    this.ebmyDate = this.ebSearch_details.bookingdate_from;

    //    var endDate=startDate.setDate(startDate.getDate() + 1);

    // this.tomorrow = this.search_details.tripdate_from;
    //   // this.tomorrow = this.tomorrow.getDate() + 1;
    this.checkempty();
    this.ebShowSingle1 = true;
    this.ebShowMultiple1 = true;
    // document.getElementById("rdiv").innerHTML = "sdfsdfsef";


    if (
      this.ebSearch_details.bookingdate_from != "" &&
      this.ebSearch_details.bookingdate_to != ""
    ) {
      this.ebdownd = false;
      //  this.disablebtn = true;
      // this.checkempty();
    } else {
      this.ebdownd = true;
    }
  }

  // Unused Functions TBD - Yugant
  // reset() {
  //   this.input.value = "";
  //   this.search_details.tripdate_from = "";
  //   this.tomorrow = "";
  // }

  // reset2() {
  //   this.input2.value = "";
  //   this.search_details.tripdate_to = "";
  // }

  reset(fromInput) {
    if (fromInput == 'input3') {
      this.matInput3.value = "";
      this.ebSearch_details.bookingdate_from = "";
      this.ebTomorrow1 = "";
      this.isEmpty();
    }

    if (fromInput == 'input4') {
      this.matInput4.value = "";
      this.ebSearch_details.bookingdate_to = "";
      this.isEmpty();
    }
  }

  checkDate() {
    this.ebInvalidDate = false;
    if (
      this.ebSearch_details.bookingdate_to != " " &&
      this.ebSearch_details.bookingdate_to != "" &&
      this.ebSearch_details.bookingdate_to != null
    ) {
      var FromDate = this.ebSearch_details.bookingdate_from;
      FromDate.setDate(FromDate.getDate() - 1);

      if (
        FromDate >=
        this.ebSearch_details.bookingdate_to
      ) {
        this.ebInvalidDate = true;
      }
    }
  }
  keypresshandler(event) {
    var charCode = event.keyCode;
    //Non-numeric character range
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
  }
  incresedate() {
    var tomorrow = (document.getElementById("did") as HTMLInputElement).value;
    var tam = new Date(tomorrow);

    this.ebFinal = tam.setDate(tam.getDate());
    this.ebFinal = new Date(this.ebFinal);

    // alert(this.final);
    //alert(this.search_details.bookingdate_from);
  }
  getdownload1() {
    //req.body.fromdate != "" && req.body.todate
    this.noresult = "";

    this.loader = true;

    var data = {
      order_id: this.booking_details_info.ORDER_ID
    };
    // console.log("data",data)
    this.vernostService.downloadReport(data).subscribe(
      result => {
        // console.log("result",result.size);
        this.noresult = "";
        if (result.size != 0) {
          saveAs(result, "ManageBooking.csv");
        } else {
          this.noresult = "Result Not Found";
        }
        this.loader = false;
      },
      err => { }
    );
  }
  getdownload() {
    //req.body.fromdate != "" && req.body.todate
    this.noresult = "";
    if (this.isJpNumber == false && this.ebisPnr == false && this.ebisOrd == false &&
      this.ebisFname == false && this.ebisLname == false) {

      this.loader = true;
      var Todate = this.ebSearch_details.bookingdate_to;
      if (Todate != "") {
        Todate.setDate(Todate.getDate());
      }
      this.ebSearch_details.bookingdate_from = this.datePipe.transform(
        this.ebSearch_details.bookingdate_from,
        "yyyy-MM-dd"
      );
      Todate = this.datePipe.transform(
        Todate,
        "yyyy-MM-dd"
      );

      var boofrom = this.ebSearch_details.bookingdate_from;
      var bookto = Todate;
      // console.log("boofrom222", boofrom);
      // console.log("bookto222", bookto);
      // document.getElementById("rdiv").innerHTML = "hefrerf";
      var AirLine_Pnr = this.ebSearch_details.airlinepnr;
      var BOOKING_REF_NO = (this.ebSearch_details.order_id.toString().length <= 15 ? this.ebSearch_details.order_id.slice(4, this.ebSearch_details.order_id.length) : this.ebSearch_details.order_id);
      var data = {
        booking_fromdate: boofrom,
        booking_todate: bookto,
        jp_number:  this.ebTypeOfRedemption === "R" ? ("00" + this.ebSearch_details.jp_number) : this.ebSearch_details.jp_number,
        order_id: BOOKING_REF_NO,
        first_name: this.ebSearch_details.first_name,
        last_name: this.ebSearch_details.last_name,
        airlinepnr: AirLine_Pnr.toUpperCase(),
        status: this.ebSearch_details.status,
        Ticket_No: this.ebSearch_details.Ticket_No,
        typeOfRedemption: this.ebTypeOfRedemption
      };

      this.vernostService.downloadReport(data).subscribe(
        result => {
          // console.log("result",result.size);
          this.noresult = "";
          if (result.size != 0) {
            saveAs(result, "ManageBooking.csv");
          } else {
            this.noresult = "Result Not Found";
          }
          this.loader = false;
        },
        err => { }
      );
    }
  }
}
